/* eslint-disable react/no-array-index-key */
import React from 'react'

import { Image } from '../../components'
import { Content, Heading, Kicker } from '../../components/Typography'
import useMediaQuery from '../../hooks/useMediaQuery'
import SectionLayout from '../../layouts/SectionLayout/SectionLayout'
import { contentParser } from '../../utils/contentParser'
import {
  contentColumn,
  contentContainer,
  imageContainer,
  renderContent,
  sectionContainer,
  sectionContentContainer,
} from './BrindusaHero.module.css'

const BrindusaHero = ({ slice }) => {
  const {
    bioherobackground,
    bioherocontent,
    bioheroheader,
    bioheroimage,
    bioherokicker,
  } = slice
  let parsedContent = []

  if (bioherocontent === null) parsedContent = []
  if (bioherocontent) parsedContent = contentParser(bioherocontent)
  const isDesktop = useMediaQuery('(min-width: 1200px)')
  const half = Math.ceil(parsedContent.length / 2)
  const firstHalf = parsedContent.slice(0, half)
  const secondHalf = parsedContent.slice(half)

  return (
    <SectionLayout
      backGround={isDesktop ? bioherobackground : null}
      extraClassName={sectionContainer}
    >
      <div className={sectionContentContainer}>
        <div className={imageContainer}>
          {bioheroimage && (
            <Image
              alt={bioheroimage.altText || 'Kliniken Image'}
              src={bioheroimage.node.localFile.childImageSharp}
            />
          )}
        </div>
        {bioherokicker && <Kicker>{bioherokicker}</Kicker>}
        {bioheroheader && <Heading>{bioheroheader}</Heading>}
        {parsedContent.length > 0 && (
          <div className={contentContainer}>
            <div className={contentColumn}>
              <Content
                extraClassName={renderContent}
                renderContent={firstHalf}
              />
            </div>
            <div className={contentColumn}>
              <Content
                extraClassName={renderContent}
                renderContent={secondHalf}
              />
            </div>
          </div>
        )}
      </div>
    </SectionLayout>
  )
}

export default BrindusaHero
